function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnlocki = function SvgUnlocki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "nonzero",
    d: "M17.5 10.503V8.997c0-1.097-.903-2-2-2s-2 .903-2 2v2.006h1.013c.543.007.987.456.987 1v5c0 .55-.45 1-1 1h-8c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1h6V8.997c0-1.646 1.354-3 3-3s3 1.354 3 3v1.506a.5.5 0 0 1-1 0z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnlocki);
export default ForwardRef;